const heyLibbyCapabilities = [
  'Create your custom chatbot link and share on your socials.',
  'Share your heyLibby email address or set up your own custom email address with Libby.',
  'Share your heyLibby phone number or forward your existing phone number to Libby.',
  'Embed the chatbot on your website.',
  'Set up texting and unlock a popular channel.',
]

export default heyLibbyCapabilities
